import {
  Checkbox
} from "@material-tailwind/react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { handleUpgradePlan } from "../../Services/SweetAlert";
import useDebounce from "../../Services/useDebounce";
import { ADD_USERS } from "../../Utils/Constant";
import { getInitialsFromEmail } from "../../Utils/Helper";
import BasicButton from "../UI/Buttons/BasicButton";
import SearchField from "../UI/Inputs/SearchField";
import LoadingSpinner from "../UI/LoadingSpinner";

// 3. Reusable Contacts Selection Modal
export const ContactsSelectModal = ({
  open,
  onClose,
  selectedContacts = [],
  contacts = [],
  // limit = 5,
  onConfirm,
  loading,
}) => {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [displayContacts, setDisplayContacts] = useState(contacts);
  const deferredSearch = useDebounce(search, 300);

  const navigate = useNavigate();

  useEffect(() => {
    if (deferredSearch) {
      const filteredList = contacts.filter((item) =>
        item.label.toLowerCase().includes(deferredSearch.toLowerCase())
      );
      setDisplayContacts(filteredList);
    } else {
      setDisplayContacts(contacts);
    }
  }, [deferredSearch, contacts]);

  const handleChangeContacts = (value) => {
    const index = selected.findIndex(
      (contact) => contact.value === value.value
    );

    if (index !== -1) {
      setSelected(selected.filter((contact) => contact.value !== value.value));
      return;
    }

    const newContact = {
      label: value.label,
      value: value.value,
    };

    // if (selectedContacts?.length + selected.length + 1 >= limit) {
    //   handleUpgradePlan(ADD_USERS, () => {
    //     navigate(`/upgrade-plan?plan=base-plan`);
    //   });
    //   toast.error("limit to invite member exceeded", "error");
    //   return;
    // }

    setSelected([...selected, newContact]);
  };

  const handleSelectAll = (e) => {
    if (!e.target.checked) {
      setSelected(selectedContacts);
      return;
    }
    const allContacts = displayContacts.map((contact) => ({
      label: contact.label,
      value: contact.value,
    }));
    // if (allContacts.length + selectedContacts?.length >= limit) {
    //   handleUpgradePlan(ADD_USERS, () => {
    //     navigate(`/upgrade-plan?plan=base-plan`);
    //   });
    //   toast.error("limit to invite member exceeded", "error");
    //   return;
    // }
    setSelected([...allContacts]);
  };

  const handleConfirm = () => {
    onConfirm([...selectedContacts, ...selected]);
    setSelected([]);
    setSearch("");
    onClose();
  };

  return (
    <>
      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-col gap-4">
          <SearchField
            id="search-contact"
            name="search-contact"
            search={search}
            setSearch={setSearch}
            placeholder="Search contacts"
          />

          {displayContacts?.length !== 0 && (
            <div className="flex flex-col items-end justify-end">
              <Checkbox
                id="selectAll"
                label="Select All"
                onChange={handleSelectAll}
                color="blue"
                checked={selected?.length >= displayContacts?.length}
                ripple={false}
                labelProps={{
                  className:
                    "text-debatePalette-title text-md font-medium capitalize",
                }}
              />
            </div>
          )}

          <div className="h-64 overflow-auto flex flex-col gap-2 items-start w-full">
            {loading && <LoadingSpinner />}
            {displayContacts?.length === 0 && !loading && (
              <div className="flex text-lg font-semibold w-full h-full justify-center items-center">
                No contacts found
              </div>
            )}
            {displayContacts.map((member) => (
              <Checkbox
                key={member?.value}
                containerProps={{
                  className: "!flex items-center w-full",
                }}
                checked={selected
                  ?.map((contact) => contact?.label)
                  .includes(member?.label)}
                onChange={() => handleChangeContacts(member)}
                id={member?.label}
                color="blue"
                ripple={false}
                className="w-4 h-4 rounded-none before:content-none"
                label={
                  <div className="flex items-center gap-2 w-full truncate">
                    {
                      <div className="inline-flex items-center justify-center h-10 w-10 uppercase font-bold  border border-primary-basic text-primary bg-white  rounded-full">
                        {getInitialsFromEmail(member?.label)}
                      </div>
                    }
                    <p className="">{member?.label?.replace(/\s+/g, "")}</p>
                  </div>
                }
                labelProps={{
                  className:
                    "text-debatePalette-title text-md font-medium capitalize",
                }}
              />
            ))}
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <BasicButton
            variant={"outlined"}
            className={"bg-transparent "}
            onClick={() => {
              onClose();
              setSearch("");
              setSelected([]);
            }}
          >
            Cancel
          </BasicButton>
          <BasicButton
            onClick={handleConfirm}
            color={"primary"}
            className={"px-5"}
          >
            Add Selected
          </BasicButton>
        </div>
      </div>
    </>
  );
};
